require( "bootstrap-sass" );

window.toggleCommentForm = function(){
	$( "#commentForm" ).slideToggle();
}